//import types from '../actions/types';

import types from "../actions/types";
import produce from "immer/dist/immer";
//
// const initialState = {
//   selected: 'text',
//   object: null
// };

const initialState = {
  selected: null,
  object: null,
  team: false,
  teamModal: false,
  copyrightModal: false,
  sizeRef: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SELECT_OBJECT:
      return produce(state, draftState => {
        draftState.selected = action.payload.type;
        draftState.object = action.payload.object;
      });
    case types.DESELECT_OBJECTS:
      return produce(state, draftState => {
        draftState.selected = null;
        draftState.object = null;
      });
    case types.SELECT_PANE:
      return produce(state, draftState => {
        draftState.selected = action.payload.type;
        draftState.object = null;
      });
    case types.SET_SINGLE_MODE:
      return produce(state, draftState => {
        draftState.team = false;
      });
    case types.SET_TEAM_MODE:
      return produce(state, draftState => {
        draftState.team = true;
      });
    case types.SHOW_TEAM_MODAL:
      return produce(state, draftState => {
        draftState.teamModal = true;
      });
    case types.HIDE_TEAM_MODAL:
      return produce(state, draftState => {
        draftState.teamModal = false;
      });
    case types.SHOW_COPYRIGHT_MODAL:
      return produce(state, draftState => {
        draftState.copyrightModal = true;
        draftState.sizeRef = action.payload.sizeRef;
      });
    case types.HIDE_COPYRIGHT_MODAL:
      return produce(state, draftState => {
        draftState.copyrightModal = false;
      });
    case types.FACE_LOAD_OBJECTS:
      return produce(state, draftState => {
        draftState.sizeRef = action.payload.sizeRef;
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/sidebarReducer.js